import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {IdentityService} from "../api/services/identity.service";
import {catchError, map, of} from "rxjs";

export const temporaryPasswordGuard: CanActivateFn = (route, state) => {
  const identityService = inject(IdentityService)
  const router = inject(Router)

  const token = localStorage.getItem("accessToken");

  if (!token) {
    return router.createUrlTree(['/login']);
  }

  return identityService.getAuthenticatedUser$Json().pipe(
    map(res => {
      if (!res.isPasswordTemporary) {
        return router.createUrlTree(['/profile']);
      }

      return true;
    }),
    catchError(() => {
      router.createUrlTree(['/profile']);
      return of(false);
    })
  );
};
